"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/UploadStatus.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _pendingSends = require('shared/services/pendingSends');






// "Uploading 5 of 8…" while this chat has a send whose files are still going
// up, so staff wait before leaving (the parts post together at the end).
const UploadStatus = ({ conversationKey }) => {
  const summary = _pendingSends.usePendingSendsSummary.call(void 0, conversationKey)
  if (!summary) return null
  const current = Math.min(summary.uploaded + 1, summary.total)
  return (
    _react2.default.createElement('div', { className: "chat--upload-status", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}, "Uploading "
       , current, " of "  , summary.total, "…"
    )
  )
}

exports. default = _react2.default.memo(UploadStatus)
